import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';
import { Locale } from './Locale';
import { ReplaySubject } from "rxjs";
import { AppConfig } from '../../../../assets/config/appconfig';
import { map } from 'rxjs/operators';

//Create a cache service so that the locale strings can be cached on the client side based on language
let cacheableCache: { [key: string]: Observable<any> } = {};
export function cacheable<T>(returnObservable: Observable<T>, key?: string, customCache?: { [key: string]: Observable<T> }): Observable<T> {
    if (!!key && (customCache || cacheableCache)[key]) {
        return (customCache || cacheableCache)[key] as Observable<T>;
    }
    let replay = new ReplaySubject<T>(1);
    returnObservable.subscribe(
        x => replay.next(x),
        x => replay.error(x),
        () => replay.complete()
    );
    let observable = replay.asObservable();
    if (!!key) {
        if (!!customCache) {
            customCache[key] = observable;
        } else {
            cacheableCache[key] = observable;
        }
    }
    return observable;
}

@Injectable()
export class LocalesService {
    private localeURL = `${this._appConfig.settings.defaultURL}/v2/locale/`;

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
    }

    getLocalesByLang(lang: string): Observable<Locale[]> {
        return cacheable<Locale[]>(this.http.get<Locale[]>(`${this.localeURL}${lang}`), lang);
    }

    getLocaleStringObservable(lang: string, localeKey: string, localeView?: string): Observable<Locale> {
    return this.getLocalesByLang(lang).pipe(
      map((locales: Locale[]) => {
        let filteredLocale = locales.find((item) => {
          if (localeView) {
            return item.key === localeKey && (item.view == null || item.view == undefined || item.view === localeView);
          }
          else {
            return item.key === localeKey;
          }
        });
        if (filteredLocale) {
          return filteredLocale;
        } else {
          return {} as Locale;
        }
      }));
  }
}

//Create a class so that the client language being requested can be passed across components
@Injectable()
export class ConfigService {
    private localelang: string;
    private action: string;

    get languagerequested() {
        return this.localelang;
    }

    set languagerequested(value: string) {
        this.localelang = value;
    }

    get iframeAction() {
        return this.action;
    }

    set iframeAction(value: string) {
        this.action = value;
    }
}
